export default __webpack_public_path__ + "static/media/Montserrat-SemiBold.d5e0cc78.ttf";